module.exports = __webpack_public_path__ + "static/media/homepage.97093518.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage.jpg
// module id = 751
// module chunks = 3